<template>
  <section class="help">
    <p class="instr-copy">Upon selecting a trial from the home screen, select <span class="icon-number"><Number1/></span> to open the menu, <span class="icon-number"><Number2/></span> to select content, and <span class="icon-number"><Number3/></span> to view.</p>

    <div class="image-container">
      <slot name="image"></slot>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Help',

  components: {
    Number1: () => import('@/assets/svgs/number-1.svg?inline'),
    Number2: () => import('@/assets/svgs/number-2.svg?inline'),
    Number3: () => import('@/assets/svgs/number-3.svg?inline'),
  },
};
</script>

<style lang="scss" scoped>
.icon-number {
  display: inline-block;
  width: rem(24);
  height: rem(24);

  svg {
    width: 100%;
  }
}

.image-container {
  width: 100%;
  margin-top: rem(50);
  text-align: center;

  svg {
    width: 100%;
  }
}

.help {
  width: 100%;
  height: 100%;
  font-size: rem(16);
  color: #646464;

  &__col {
    width: 49%;
    @include flexbox(flex-start, space-between);
    flex-direction: column;
    max-height: 100%;
  }

  &__label,
  &__content {
    display: block;
    font-size: rem(16);
    color: #646464;
  }

  &__label {
    font-weight: $font-bold;
    min-width: rem(100);
  }

  &__item {
    @include flexbox(flex-start, flex-start);

    &:not(:last-child) {
      margin-bottom: rem(5);
    }
  }
}
</style>
